<template>
  <transition
    name="fade-scale"
    appear
  >
    <div
      v-if="visible"
      class="fixed inset-0 z-50 flex flex-col items-center justify-center"
    >
      <DotLottieVue
        :src="animationSource"
        style="height: 120px; width: 120px"
        autoplay
        loop
      />
      <p class="mt-4 text-gray-500 text-sm animate-pulse">
        {{ message }}
      </p>
    </div>
  </transition>
</template>

<script setup>
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";
import { defineProps, computed } from "vue";

const props = defineProps({
  visible: {
    type: Boolean,
    default: true,
  },
  type: {
    type: String,
    default: "loading", // loading, login, logout
  },
  userType: {
    type: String,
    default: "internal", // client, internal
  },
});

const animationSource = computed(() => {
  if (props.type === "logout") {
    return props.userType === "internal"
      ? "https://lottie.host/662dc186-a509-40af-9b4e-ca78c135ccd9/ReC7DZiijj.lottie"
      : "https://lottie.host/662dc186-a509-40af-9b4e-ca78c135ccd9/ReC7DZiijj.lottie";
  } else if (props.type === "login") {
    return props.userType === "internal"
      ? "https://lottie.host/662dc186-a509-40af-9b4e-ca78c135ccd9/ReC7DZiijj.lottie"
      : "https://lottie.host/662dc186-a509-40af-9b4e-ca78c135ccd9/ReC7DZiijj.lottie";
  } else {
    return "https://lottie.host/662dc186-a509-40af-9b4e-ca78c135ccd9/ReC7DZiijj.lottie"; // Replace with your preferred loader CDN
  }
});

const message = computed(() => {
  if (props.type === "logout") {
    return props.userType === "internal"
      ? "Logging you out. Syncing your session..."
      : "Logging you out. Please wait while we safely sign you off.";
  } else if (props.type === "login") {
    return props.userType === "internal"
      ? "Launching your dashboard. Preparing internal tools..."
      : "Launching your dashboard. Getting things ready for you!";
  } else {
    return "Loading, please wait...";
  }
});
</script>

<style scoped>
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}
.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
